<ng-container *ngIf="!currentState || !currentState.endsWith('next'); else newStyles">
  <!-- Default navigation content -->
  <nav class="main-nav main w-44px space-between-vert align-items-c" id="main-navigation" [ngClass]="'theme-' + theme" data-test-id="new-nav-main-part" aria-label="Main navigation">
    <div class="centered-content flex-d-c w-full pt-11px">
      <img class="nav-logo mb-10px" src="dist/img/quantive-circle-logo-left-navigation.svg" tabindex="-1" alt="Logo" />
      <ul>
        <li *ngFor="let screen of screens">
          <a
            class="hov-cursor-p centered-vert h-40px ink-20-v3 fs-16px w-full"
            *ngIf="screen.showScreenCondition$ | async"
            [uiTooltipTitle]="screen.key | localize"
            [uiSref]="screen.state"
            [uiOptions]="{ supercede: false }"
            [uiParams]="screen.stateParams"
            [class.bg-white]="activeScreen === screen.key"
            [class.has-badge]="screen.key === 'home' && (showHomeActionsBadge$ | async)"
            [attr.data-test-id]="'new-nav-icon-for-tab-' + screen.key"
            [attr.aria-label]="screen.ariaLabel | localize"
            uiTooltipPlacement="right"
            ui-tooltip>
            <i [uiType]="screen.icon" ui-icon></i>
          </a>
        </li>
      </ul>
    </div>

    <ul class="centered-content flex-d-c pb-11px w-full">
      <li *featureToggleEnabled="'singularity-access'" [uiTooltipTitle]="'apps' | localize" [attr.aria-label]="'apps' | localize" uiTooltipPlacement="right" ui-tooltip>
        <apps-dropdown class="ui-button-webkit-appearance-none" data-test-id="new-navigation-apps-dropdown-button"></apps-dropdown>
      </li>
      <li>
        <a
          class="hov-cursor-p centered-vert h-40px ink-20-v3 fs-16px w-full gh-font-icon-add-from-marketplace"
          *ngIf="showMarketplace$ | async"
          [uiTooltipTitle]="'marketplace' | localize"
          [attr.aria-label]="'marketplace' | localize"
          (click)="setMarketplaceCookie()"
          uiTooltipPlacement="right"
          href="/marketplace"
          gh-dropdown-toggle
          ui-tooltip
          aria-describedby="marketplace_aria_description"
          data-test-id="new-nav-icon-for-marketplace">
        </a>
        <span class="a11y-description" id="marketplace_aria_description">{{ "marketplace" | localize }} - {{ "this_links_leads_to_currently_inaccessible_content" | localize }}</span>
      </li>
      <li>
        <a
          class="hov-cursor-p centered-vert h-40px ink-20-v3 fs-16px w-full"
          *ngIf="settingsScreen.showScreenCondition$ | async"
          [uiTooltipTitle]="settingsScreen.key | localize"
          [uiSref]="settingsScreen.state"
          [ngClass]="'gh-font-icon-' + settingsScreen.icon"
          [class.bg-white]="activeScreen === settingsScreen.key"
          [attr.aria-label]="'settings' | localize"
          uiTooltipPlacement="right"
          ui-tooltip
          data-test-id="new-nav-icon-for-settings">
        </a>
      </li>
      <li [uiTooltipTitle]="'support_center' | localize" uiTooltipPlacement="right" ui-tooltip>
        <help-dropdown class="ui-button-webkit-appearance-none"></help-dropdown>
      </li>
      <li>
        <button
          class="notif-btn h-40px w-full"
          [uiTooltipTitle]="'notifications' | localize"
          [attr.aria-label]="unreadNotificationsCountAriaLabel"
          (click)="openNotificationsModal()"
          uiTooltipPlacement="right"
          ui-tooltip>
          <ui-badge *ngIf="{ count: unreadNotificationsCount } as context" [uiCount]="context.count" [uiStyle]="{ right: '2px' }" [uiOffset]="[-2, 0]">
            <i class="ink-20-v3 fs-16px" ui-icon uiType="notifications"></i>
          </ui-badge>
        </button>
      </li>
      <li class="mt-18px">
        <profile-dropdown class="ui-button-webkit-appearance-none"></profile-dropdown>
      </li>
    </ul>
  </nav>
  <sub-navigation *ngIf="activeScreen" [activeScreen]="activeScreen"></sub-navigation>
</ng-container>

<!-- New Styles Template -->
<ng-template #newStyles>
  <!-- Navigation with new styles -->
  <navigation-v3></navigation-v3>
</ng-template>
